import { prepareInfrastructure } from 'shared/mappers/infrastructure';
import {
  IGetInfrastructureOptions,
  TGetInfrastructureResponse_1,
  IGetInfrastructureResponse200,
  IGetInfrastructureResponse400,
  TGetInfrastructureResponseError,
  fetchGetInfrastructure,
} from 'shared/repositories/infrastructure-caching/v4/get-infrastructure';
import { IApplicationContext } from 'shared/types/applicationContext';
import { IInfrastructureCategory } from 'shared/types/infrastructure';
import { TRequestParamsWithoutHttpApi } from 'shared/types/request';
import { assertResponseError } from 'shared/utils/errors';
import { request } from 'shared/utils/request';

type TRequestParameters = TRequestParamsWithoutHttpApi<
  IGetInfrastructureOptions<IGetInfrastructureResponse200, IGetInfrastructureResponse400>
>;

type TFetchInfrastructureParameters = TRequestParameters & {
  regionId: number;
};

export const fetchInfrastructure = async (
  context: IApplicationContext,
  { regionId, ...parameters }: TFetchInfrastructureParameters,
): Promise<IInfrastructureCategory[]> =>
  request<IInfrastructureCategory[], TRequestParameters, TGetInfrastructureResponse_1, TGetInfrastructureResponseError>(
    context,
    {
      parameters,
      domain: 'fetchInfrastructure',
      defaultValue: [],
      prepareFunction: response => prepareInfrastructure({ response, config: context.config, regionId }),
      fetchFunction: fetchGetInfrastructure,
      errorHandler: assertResponseError,
    },
  );
